import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { List, ListItem, ListItemText, Grid } from '@material-ui/core'

export default function TabPanelNoteContents({
  classes,
  TabPanel,
  selectedTab,
  archives,
  setArchiveSelected
}) {
  return(
    <TabPanel value={selectedTab} index={0} >
      <List className={classes.List__root}>
        {archives.map(archive =>
          <Grid item sm={12} xs={12} key={archive.id}>
            <ListItem 
              alignItems='flex-start' 
              onClick={() => setArchiveSelected(archive)} 
              className={classes.List__root_item}
            >
              <ListItemText
                primary={archive.name}
                secondary={archive.secondary}
              />
              <ArrowForwardIosIcon fontSize='small' />
            </ListItem>
          </Grid>
        )}
      </List>
    </TabPanel>
  )
}